import React, { useCallback, useMemo, useRef } from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { TreeView } from '../../../../../common/components/layout';
import { getCenteredEntities, getEntitiesWithVisibility } from '../../../../../map/utils/mapFunctions';
import { PipelineCenterlineExact } from '../../../../../mission/models/PipelineCenterline';

const PipelineCenterlineTreeView = ({ pipelineCenterlines, setPipelineCenterlines, setCenteredGeometries, disabled }) => {
  const handleCenterlinesCenterClick = useCallback(
    (item) => {
      setCenteredGeometries(getCenteredEntities(pipelineCenterlines, item.id));
    },
    [pipelineCenterlines, setCenteredGeometries]
  );

  const handleCenterlinesVisibilityClick = useCallback(
    (item, isToggled) => {
      setPipelineCenterlines((oldCenterlines) => getEntitiesWithVisibility(oldCenterlines, item.id, isToggled));
    },
    [setPipelineCenterlines]
  );

  const { current: centerlineItemActions } = useRef([
    { id: 'centerline-center', icons: { default: 'gps_fixed' }, onClick: handleCenterlinesCenterClick },
    {
      id: 'centerline-visibility',
      icons: { default: 'visibility', toggled: 'visibility_off' },
      onClick: handleCenterlinesVisibilityClick,
    },
  ]);

  const centerlineItems = useMemo(
    () => [
      {
        id: 'root',
        label: `${i18n.t('patrol.details.centerlines')}: ${pipelineCenterlines.length}`,
        actions: centerlineItemActions,
        children: pipelineCenterlines.map((centerline, index) => ({
          id: index,
          label: `${i18n.t('patrol.details.pipelineCenterline')} #${index + 1}`,
          actions: centerlineItemActions,
          disabled,
        })),
        disabled,
      },
    ],
    [pipelineCenterlines, centerlineItemActions, disabled]
  );

  return <TreeView id="centerlines" items={centerlineItems} />;
};

PipelineCenterlineTreeView.propTypes = {
  disabled: PropTypes.bool,
  pipelineCenterlines: PropTypes.arrayOf(PipelineCenterlineExact),
  setCenteredGeometries: PropTypes.func.isRequired,
  setPipelineCenterlines: PropTypes.func.isRequired,
};

PipelineCenterlineTreeView.defaultProps = {
  pipelineCenterlines: [],
  disabled: false,
};

export default PipelineCenterlineTreeView;
